module.exports = __webpack_public_path__ + "static/img/5.f5c83f8c.png";